import React, { useRef, useState } from "react";
import "./RentAgreementFormat.scss";
import ToolBar from "./ToolBar";
import { useLocation, useNavigate } from "react-router-dom";
import FileUploadBox from "../UploadFile/FileUploadBox";

export default function RentAgreementFormat() {

  const [file,setFile] = useState(null)


  const selectRange = (e) => {
    const range = document.createRange();
    range.selectNodeContents(e.target);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }

  const editorRef = useRef(null);


    const location = useLocation();
  const user = location.state;

   const navigate = useNavigate();
      const handleClick = () => {
      
      navigate('/Rental-manager', {
        state: {mobileNumber:user?.tenantUserName},
      })
    }




  return (
    <div className="print-wrapper">


      <ToolBar editorRef={editorRef} />
       <div className="flex gap-10 noPrint" style={{cursor:"pointer",position:"sticky",top:"60px", marginLeft:"20px"}} onClick={handleClick}>
            <div 
            className="noPrint"
            style={{cursor:"pointer"}}
            ><i className="fa-solid fa-arrow-left"></i></div>
             <strong>Back</strong>

          </div>
      <div
        ref={editorRef}
      >
        {/* PAGE 1 */}
        <section className="Agreement_page" aria-label="Rent Agreement - Page 1" >
          <header className="page-header">
            <div className="stamp-row">
              <div className="" style={{width:"100%"}}>
                 <FileUploadBox
                          onUploadFile={setFile}
                          fileUpload={file}
                          style={{ maxWidth: "100%" ,minHeight:"380px"}}
                          show="true"
                           accept="image/jpeg,image/png,image/jpg"
                             title="Drag & Drop your stamp here or click to select stamp"
                        />
   
              </div>


            </div>
          </header>
          <br />
          <br />
          <div className="title-block">
            <div className="title">RENT AGREEMENT</div>
          </div>

          <br />
          <br />

          <div className="content" >
            <p className="prewrap">
              THIS RENT AGREEMENT IS MADE AT GURGAON ON THIS <strong className="editor" onClick={selectRange} contentEditable={true}>............................ ............</strong> BETWEEN; <strong onClick={selectRange} contentEditable={true}>................................................. ............
                ....</strong> (hereinafter called the <strong>LESSOR</strong> which expression shall unless repugnant to the context include his/her heirs, executors, adnunistrators, representatives and assigns) of the ONE PART.
            </p>

            <br />

            <p style={{ textAlign: "center", fontSize: "20px" }}><strong>And</strong></p>

            <br />
            <p>
              <strong onClick={selectRange} >..............................................................
                ...............................  </strong> called the <strong> LESSEE(S) </strong>which expression shall unless repugnant to the context or meaning there of include its successors and assigns) of the other part WITNESSETH as follows.
            </p>

            <p>THE EXPRESSION LESSOR and LESSEE shall mean and include their respective heirs, sucpessor representatives and assigns etc.</p>
          </div>

          <p style={{ marginBlock: "20px" }}>THE EXPRESSION LESSOR and LESSEE shall mean and include their respective heirs, sucpessor representatives and assigns etc.</p>

          <div className="content">
            <p><strong>WHEREAS</strong> the LESSOR is the lawful owner in possession of <strong onClick={selectRange} contentEditable={true}>...........................................................................................</strong> <strong>On request of the LESSEE the LESSOR has agreed to rent out the</strong> above said PROPERTY to the LESSER and the LESSER agrend to take it on rent</p>
            <br />
            <p><strong>WHEREAS</strong> the LESSOR has represented that the sand property is free from all encumbrances and the LESSOR has a clean and onrestricted right to the said property and is legally competent to enter inte this Rent Agreement on the terms and conditions contained herein.</p>
            <br />

            <p style={{ textAlign: "center", fontSize: "20px" }}><strong>NOW THIS DEED WITNESSETH AS FOLLOWS</strong></p>
            <br />

            <ol type="1"    >
             

              <li>
 The possession has been given to the LESSEE by LESSOR and the tenancy shall commence <strong  onClick={selectRange} contentEditable={true}>.............</strong> and shall remain for a perind of <strong  onClick={selectRange} contentEditable={true}>...........</strong> Le upto <strong  onClick={selectRange} contentEditable={true}>........</strong>. That the tenancy can be renewed after <span  onClick={selectRange} contentEditable={true}>.......</span> with increase in rent by <strong  onClick={selectRange} contentEditable={true}>.....</strong> on terms as mutually agreed.

              </li>

              <li>
            That the LESSEE shall pay to the LESSOR for the above said Property the rent of <strong  onClick={selectRange} contentEditable={true}>..............</strong> per month in advance on or before 05th day of every English Calendar munth through the Cash/Choque/Online Transfer failing which the owner can terminate this agreement and security amount deposited with the LESSOR shall be forfeited.
              </li>

              <li>
    That the LESSEE shall pay of <strong  onClick={selectRange} contentEditable={true}>................</strong> as interest free security to the LESSOR by cash/cheque/online transfer which is refundable <strong>(not adjustable in rent)</strong> after deducting the electricity or any charges, damage of any fixture fittings etc. if any, at the time of handing over the peaceful vacant possession of the Property to the LESSOR.
              </li>

              <li>
That the LESSEE shall use the property exclusively for <strong>Residential Purpose and</strong> shall not sublet the property without the written permission of the LESSOR. The LESSEE agrees to not use the premises for any Commercial activities or obtain GST ete.
              </li>

              <li>
            That the LESSEE shall pay per month for water & maintenance charges and shall also pay electricity charges as per consumption to the LESSOR/Respective Authority
              </li>

              <li>
That the LESSEE shall comply with all the rules and regulations of the local authorities whatsoever in relation to the said property.
              </li>
<li>That the LESSEE shall not carry out any structural additions or alterations to the building layout, fittings and fixtures without the prior written consent of the LESSOR.</li>
              <li>
That the LESSEE at the time of occupation shall see that all the electrical, sanitary fittings and fixtures are intact and or in perfect working order. The LESSEE shall be responsible to restore them in the same condition except natural wear and tear and damages by act of nature.
              </li>

              <li>
That the LESSEE shall permit the LESSOR or any of his/her/their authorized agent to enter upon the said property for inspection and to carry the necessary repair at all reasonable times.
              </li>

              <li>
That day to day repairs such as fuses, leakage of water taps etc, have to be done by the LESSEE at his own costs.
              </li>

              <li>
That at the expiry of Rent period the LESSEE shall handover the physical vacant possession of the cald property to the LESSOR with all the fittings and fixtures intact and in perfect work <strong style={{textDecoration:"underline"}}>natural wear and tear</strong>, With the mutual consent the rent period/lease can be exfendesURUGRAM CERT MALIK
              </li>


              <li>
              That in cave the LESSEE makes default in making the payment of cent or commits any other breach of this deed the LESSOR shall be entitled to get back the possession of the property immediately thereafter arcorating to law.
              </li>

              <li>
            This agreement has a lockan period of <strong  onClick={selectRange} contentEditable={true}>.....</strong> before which of the LESSEE vacates the premises, the security amount will remain forfeited by the LESSOR and no refund will be possible in any circumstances.
              </li>

              <li>
                That this Rent Agreement can be terruinated by either of the parties by serving <span  onClick={selectRange} contentEditable={true}>...........</span> month written notice subject to lockin period. The notice period is valid from the 1st day of the month only and not from the middle of the month.
              </li>

              <li>
              That the LESSEE shall not do or cause to do any act or activities of illegal, immoral, unsocial nature in the said premises and will not create any nuisance to the neighborhood in any manner whatsoever.
              </li>

              <li>
                Keya of the property should be handed over to the lessor at the time of vacation of the property.
              </li>

              <li>
             17. Safety Security of men and materials of the property shall be LESSEE's responsibility and LESSOR will not be responsible for any loss/damage done by LESSEE. Cleanliness and maintenance of property area shall be LESSEE responsibility,

              </li>

              <li>
               The LESSEE will be held responsible on account of any mishappening, accident, loan, GST ete, in the abuve said premises The LESSOR will not be liable for any kind of illegal activities of the LISSUE
              </li>

              <li>
               In case any servant or individual known to the LESSEE resides at the aforementioned premises and engages in any wrongful conduct/act, the LESSEE shall be held fully responsible for it
              </li>

              <li>
             The LESSEE will be frable to pay for the service /repair of all the appliances in the premises.
              </li>

              <li>
           Any dispute out of this agreement shall be limited to Gurgaon Jurisdiction.
              </li>

              <li>
           
               The Electricity reading us on ____________________________ is ____________________________
              </li>



            </ol>

          </div>

          <div className="content">

            <br />
            <p><strong>IN WITNESS WHEREOF THE PARTIES ABOVE NAMED HAVE AFFIXED THEIR SIGNATURES ON THIS DEED OF AGREEMENT ON THE DATE MONTH AND YEAR WRITTEN IN THE PRESENCE OF THE WITNESSES GIVEN BELOW:</strong></p>
            <br />

            <div >
              <strong>WITNESSES</strong>
            </div>
            <br />
            <div style={{ display: "flex" }}>
              <strong style={{ flex: "1 1 60%", }}>1.</strong> <strong style={{ flex: "1 1 40%", }}>LESSOR</strong>
            </div>
            <br />
            <br />
            <br />


            <div style={{ display: "flex" }}>
              <strong style={{ flex: "1 1 60%" }}>2.</strong> <strong style={{ flex: "1 1 40%", }}>LESSOR</strong>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
}
